export function downloadFile(src: string, fileName: string) {
  const downloadLink = document.createElement('a');

  downloadLink.href = src;
  downloadLink.download = fileName;
  downloadLink.click();

  downloadLink.remove();
}
